module.exports = __webpack_public_path__ + "static/media/movie.7e547bc0.webp";